let popup = {};
/**
 * set a cookie to be displayed the next time the customer gets on the account page
 * @param {string} message to be displayed in popup
 */
popup.setPopupCookie = (message) => {
    const cookie = require('js-cookie');
    const cookieOptions = {
        secure: true,
        path: '/',
        expires: 1825
    };
    cookie.set('accountPopup', message, cookieOptions);
};

module.exports = popup;
